import { Link } from "react-router-dom";

/**
 * Wiederverwendbarer Hero.
 * Props:
 *   eyebrow   – kleiner Text über dem Titel
 *   title     – H1
 *   text      – Teaser-Text
 *   ctaLabel  – Button-Text (default: "Mehr erfahren")
 *   ctaTo     – Button-Ziel (default: "/teams")
 *   bgImage   – Pfad aus /public (optional, z.B. "/hero.jpg")
 */
export default function Hero({
  eyebrow,
  title,
  text,
  ctaLabel = "Mehr erfahren",
  ctaTo = "/teams",
  bgImage,
}) {
  return (
    <section className="relative bg-primary text-white overflow-hidden">
      {/* Hintergrundbild */}
      {bgImage && (
        <>
          <img
            src={bgImage}
            alt=""
            loading="eager"
            fetchpriority="high"
            decoding="async"
            className="absolute inset-0 h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-primary/70" />
        </>
      )}

      {/* Diagonaler Akzent-Streifen rechts */}
      <div
        className="absolute right-0 top-0 h-full w-1/3 bg-accent/10 origin-top-right"
        style={{ clipPath: "polygon(30% 0, 100% 0, 100% 100%, 0% 100%)" }}
      />
      <div
        className="absolute right-0 top-0 h-full w-8 bg-accent"
        style={{ clipPath: "polygon(0 0, 100% 0, 100% 100%, 40% 100%)" }}
      />

      <div className="relative mx-auto max-w-6xl px-4 py-28 md:py-40">
        {eyebrow && (
          <p className="text-accent font-semibold tracking-widest uppercase text-xs mb-4">
            {eyebrow}
          </p>
        )}
        <h1 className="max-w-3xl text-5xl md:text-7xl font-extrabold leading-none uppercase tracking-tight">
          {title}
        </h1>
        {text && (
          <p className="mt-6 max-w-xl text-white/85 text-lg leading-relaxed">
            {text}
          </p>
        )}
        <Link
          to={ctaTo}
          className="mt-10 inline-flex items-center gap-2 rounded-none bg-accent px-8 py-3 font-bold text-white uppercase tracking-wide text-sm hover:bg-white hover:text-primary transition-colors"
        >
          {ctaLabel}
          <svg className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
          </svg>
        </Link>
      </div>
    </section>
  );
}
